var map = {
	"./+forgot/forgot.module": [
		"./src/app/+auth/+forgot/forgot.module.ts",
		"common",
		"forgot.module"
	],
	"./+locked/locked.module": [
		"./src/app/+auth/+locked/locked.module.ts",
		"locked.module"
	],
	"./+login/login.module": [
		"./src/app/+auth/+login/login.module.ts",
		"login.module"
	],
	"./+register/register.module": [
		"./src/app/+auth/+register/register.module.ts",
		"register.module.0"
	],
	"./../mutual/cost-center/cost-center.module": [
		"./src/app/modules/mutual/cost-center/cost-center.module.ts",
		"common",
		"cost-center.module"
	],
	"./../mutual/funding-source/funding-source.module": [
		"./src/app/modules/mutual/funding-source/funding-source.module.ts",
		"common",
		"funding-source.module"
	],
	"./../mutual/programmatic-structure/programmatic-structure.module": [
		"./src/app/modules/mutual/programmatic-structure/programmatic-structure.module.ts",
		"common",
		"programmatic-structure.module"
	],
	"./../mutual/ubigeo/ubigeo.module": [
		"./src/app/modules/mutual/ubigeo/ubigeo.module.ts",
		"common",
		"ubigeo.module"
	],
	"./../mutual/vendor/vendor.module": [
		"./src/app/modules/mutual/vendor/vendor.module.ts",
		"common",
		"vendor.module"
	],
	"./../treasury/bank-account/bank-account.module": [
		"./src/app/modules/treasury/bank-account/bank-account.module.ts",
		"common",
		"bank-account.module"
	],
	"./../treasury/income-nature/income-nature.module": [
		"./src/app/modules/treasury/income-nature/income-nature.module.ts",
		"common",
		"income-nature.module"
	],
	"./../treasury/voucher/voucher.module": [
		"./src/app/modules/treasury/voucher/voucher.module.ts",
		"common",
		"voucher.module"
	],
	"./absence/absence.module": [
		"./src/app/modules/mutual/absence/absence.module.ts",
		"common",
		"absence.module"
	],
	"./afp/afp.module": [
		"./src/app/modules/mutual/afp/afp.module.ts",
		"common",
		"afp.module"
	],
	"./attachment/attachment.module": [
		"./src/app/modules/mutual/attachment/attachment.module.ts",
		"common",
		"attachment.module"
	],
	"./bank-account/bank-account.module": [
		"./src/app/modules/treasury/bank-account/bank-account.module.ts",
		"common",
		"bank-account.module"
	],
	"./bank-statement/bank-statement.module": [
		"./src/app/modules/treasury/bank-statement/bank-statement.module.ts",
		"common",
		"bank-statement.module"
	],
	"./bank/bank.module": [
		"./src/app/modules/mutual/bank/bank.module.ts",
		"common",
		"bank.module"
	],
	"./cash-movement/cash-movement.module": [
		"./src/app/modules/treasury/cash-movement/cash-movement.module.ts",
		"common",
		"cash-movement.module"
	],
	"./clock-entry/clock-entry.module": [
		"./src/app/modules/mutual/clock-entry/clock-entry.module.ts",
		"common",
		"clock-entry.module"
	],
	"./close-assistance/close-assistance.module": [
		"./src/app/modules/mutual/close-assistance/close-assistance.module.ts",
		"common",
		"close-assistance.module"
	],
	"./contract-generate/contract-generate.module": [
		"./src/app/modules/mutual/contract-generate/contract-generate.module.ts",
		"common",
		"contract-generate.module"
	],
	"./contract-parameters/contract-parameters.module": [
		"./src/app/modules/mutual/contract-parameters/contract-parameters.module.ts",
		"common",
		"contract-parameters.module"
	],
	"./contract-type/contract-type.module": [
		"./src/app/modules/mutual/contract-type/contract-type.module.ts",
		"common",
		"contract-type.module"
	],
	"./cost-center-division/cost-center-division.module": [
		"./src/app/modules/mutual/cost-center-division/cost-center-division.module.ts",
		"common",
		"cost-center-division.module"
	],
	"./cost-center/cost-center.module": [
		"./src/app/modules/mutual/cost-center/cost-center.module.ts",
		"common",
		"cost-center.module"
	],
	"./currency-type/currency-type.module": [
		"./src/app/modules/mutual/currency-type/currency-type.module.ts",
		"common",
		"currency-type.module"
	],
	"./data-extraction/data-extraction.module": [
		"./src/app/modules/administrator/data-extraction/data-extraction.module.ts",
		"common",
		"data-extraction.module"
	],
	"./deduction-afp/deduction-afp.module": [
		"./src/app/modules/mutual/deduction-afp/deduction-afp.module.ts",
		"common",
		"deduction-afp.module"
	],
	"./deduction-hold/deduction-hold.module": [
		"./src/app/modules/mutual/deduction-hold/deduction-hold.module.ts",
		"common",
		"deduction-hold.module"
	],
	"./disability-type/disability-type.module": [
		"./src/app/modules/mutual/disability-type/disability-type.module.ts",
		"common",
		"disability-type.module"
	],
	"./education-type/education-type.module": [
		"./src/app/modules/mutual/education-type/education-type.module.ts",
		"common",
		"education-type.module"
	],
	"./employee-attendance/employee-attendance.module": [
		"./src/app/modules/mutual/employee-attendance/employee-attendance.module.ts",
		"common",
		"employee-attendance.module"
	],
	"./employee-contract-type/employee-contract-type.module": [
		"./src/app/modules/mutual/employee-contract-type/employee-contract-type.module.ts",
		"common",
		"employee-contract-type.module"
	],
	"./employee-manager/employee-manager.module": [
		"./src/app/modules/mutual/employee-manager/employee-manager.module.ts",
		"common",
		"employee-manager.module"
	],
	"./employee-payroll/employee-payroll.module": [
		"./src/app/modules/mutual/employee-payroll/employee-payroll.module.ts",
		"common",
		"employee-payroll.module"
	],
	"./employee-ttype/employee-ttype.module": [
		"./src/app/modules/mutual/employee-ttype/employee-ttype.module.ts",
		"common",
		"employee-ttype.module"
	],
	"./employee-type/employee-type.module": [
		"./src/app/modules/mutual/employee-type/employee-type.module.ts",
		"common",
		"employee-type.module"
	],
	"./employee/employee.module": [
		"./src/app/modules/mutual/employee/employee.module.ts",
		"common",
		"employee.module"
	],
	"./employer-contribution/employer-contribution.module": [
		"./src/app/modules/mutual/employer-contribution/employer-contribution.module.ts",
		"common",
		"employer-contribution.module"
	],
	"./employment-regime/employment-regime.module": [
		"./src/app/modules/mutual/employment-regime/employment-regime.module.ts",
		"common",
		"employment-regime.module"
	],
	"./eps-plan/eps-plan.module": [
		"./src/app/modules/mutual/eps-plan/eps-plan.module.ts",
		"common",
		"eps-plan.module"
	],
	"./eps/eps.module": [
		"./src/app/modules/mutual/eps/eps.module.ts",
		"common",
		"eps.module"
	],
	"./evaluation-type/evaluation-type.module": [
		"./src/app/modules/mutual/evaluation-type/evaluation-type.module.ts",
		"common",
		"evaluation-type.module"
	],
	"./executing-unit/executing-unit.module": [
		"./src/app/modules/mutual/executing-unit/executing-unit.module.ts",
		"common",
		"executing-unit.module"
	],
	"./expense-nature/expense-nature.module": [
		"./src/app/modules/mutual/expense-nature/expense-nature.module.ts",
		"common",
		"expense-nature.module"
	],
	"./fiscal-year/fiscal-year.module": [
		"./src/app/modules/mutual/fiscal-year/fiscal-year.module.ts",
		"common",
		"fiscal-year.module"
	],
	"./formation-ttype/formation-ttype.module": [
		"./src/app/modules/mutual/formation-ttype/formation-ttype.module.ts",
		"common",
		"formation-ttype.module"
	],
	"./frequency-type/frequency-type.module": [
		"./src/app/modules/mutual/frequency-type/frequency-type.module.ts",
		"common",
		"frequency-type.module"
	],
	"./front-testing/front-testing.module": [
		"./src/app/modules/administrator/front-testing/front-testing.module.ts",
		"common",
		"front-testing.module"
	],
	"./funding-source/funding-source.module": [
		"./src/app/modules/mutual/funding-source/funding-source.module.ts",
		"common",
		"funding-source.module"
	],
	"./general-data/general-data.module": [
		"./src/app/modules/treasury/general-data/general-data.module.ts",
		"common",
		"general-data.module"
	],
	"./generation/generation.module": [
		"./src/app/modules/treasury/generation/generation.module.ts",
		"common",
		"generation.module"
	],
	"./holiday/holiday.module": [
		"./src/app/modules/mutual/holiday/holiday.module.ts",
		"common",
		"holiday.module"
	],
	"./home-accounting/home-accounting.module": [
		"./src/app/modules/accounting/home-accounting/home-accounting.module.ts",
		"common",
		"home-accounting.module"
	],
	"./home-administrator/home-administrator.module": [
		"./src/app/modules/administrator/home-administrator/home-administrator.module.ts",
		"common",
		"home-administrator.module"
	],
	"./home-mutual/home-mutual.module": [
		"./src/app/modules/mutual/home-mutual/home-mutual.module.ts",
		"common"
	],
	"./home-treasury/home-treasury.module": [
		"./src/app/modules/treasury/home-treasury/home-treasury.module.ts",
		"common",
		"home-treasury.module"
	],
	"./import-absence-lave/import-absence-leave.module": [
		"./src/app/modules/mutual/import-absence-lave/import-absence-leave.module.ts",
		"common",
		"import-absence-leave.module"
	],
	"./import-addendum/import-addendum.module": [
		"./src/app/modules/mutual/import-addendum/import-addendum.module.ts",
		"common",
		"import-addendum.module"
	],
	"./income-nature/income-nature.module": [
		"./src/app/modules/treasury/income-nature/income-nature.module.ts",
		"common",
		"income-nature.module"
	],
	"./income/income.module": [
		"./src/app/modules/treasury/income/income.module.ts",
		"common"
	],
	"./interface-afp/interface-afp.module": [
		"./src/app/modules/mutual/interface-afp/interface-afp.module.ts",
		"common",
		"interface-afp.module"
	],
	"./interface-airhsp/interface-airhsp.module": [
		"./src/app/modules/mutual/interface-airhsp/interface-airhsp.module.ts",
		"common",
		"interface-airhsp.module"
	],
	"./interface-bank-transfer/interface-bank-transfer.module": [
		"./src/app/modules/mutual/interface-bank-transfer/interface-bank-transfer.module.ts",
		"common",
		"interface-bank-transfer.module"
	],
	"./interface-biometric-time-clock/interface-biometric-time-clock.module": [
		"./src/app/modules/mutual/interface-biometric-time-clock/interface-biometric-time-clock.module.ts",
		"common",
		"interface-biometric-time-clock.module"
	],
	"./interface-mcpp/interface-mcpp.module": [
		"./src/app/modules/mutual/interface-mcpp/interface-mcpp.module.ts",
		"common",
		"interface-mcpp.module"
	],
	"./interface-plame/interface-plame.module": [
		"./src/app/modules/mutual/interface-plame/interface-plame.module.ts",
		"common",
		"interface-plame.module"
	],
	"./interface/interface.module": [
		"./src/app/modules/treasury/interface/interface.module.ts",
		"common",
		"interface.module"
	],
	"./job-title/job-title.module": [
		"./src/app/modules/mutual/job-title/job-title.module.ts",
		"common",
		"job-title.module"
	],
	"./labor-law/labor-law.module": [
		"./src/app/modules/mutual/labor-law/labor-law.module.ts",
		"common",
		"labor-law.module"
	],
	"./level-prog-structure/level-prog-structure.module": [
		"./src/app/modules/mutual/level-prog-structure/level-prog-structure.module.ts",
		"common",
		"level-prog-structure.module"
	],
	"./massive-employee/massive-employee.module": [
		"./src/app/modules/mutual/massive-employee/massive-employee.module.ts",
		"common",
		"massive-employee.module"
	],
	"./mcpp-concept/mcpp-concept.module": [
		"./src/app/modules/mutual/mcpp-concept/mcpp-concept.module.ts",
		"common",
		"mcpp-concept.module"
	],
	"./mcpp-type/mcpp-type.module": [
		"./src/app/modules/mutual/mcpp-type/mcpp-type.module.ts",
		"common",
		"mcpp-type.module"
	],
	"./memo-type/memo-type.module": [
		"./src/app/modules/treasury/memo-type/memo-type.module.ts",
		"common",
		"memo-type.module"
	],
	"./merit-fault/merit-fault.module": [
		"./src/app/modules/mutual/merit-fault/merit-fault.module.ts",
		"common",
		"merit-fault.module"
	],
	"./moduleSystem/moduleSystem.module": [
		"./src/app/_seguridad/moduleSystem/moduleSystem.module.ts",
		"common",
		"moduleSystem.module"
	],
	"./mpayroll-concept/mpayroll-concept.module": [
		"./src/app/modules/mutual/mpayroll-concept/mpayroll-concept.module.ts",
		"common",
		"mpayroll-concept.module"
	],
	"./occupation-list/occupation-list.module": [
		"./src/app/modules/mutual/occupation-list/occupation-list.module.ts",
		"common",
		"occupation-list.module"
	],
	"./occupation-ttype/occupation-ttype.module": [
		"./src/app/modules/mutual/occupation-ttype/occupation-ttype.module.ts",
		"common",
		"occupation-ttype.module"
	],
	"./office-type/office-type.module": [
		"./src/app/modules/mutual/office-type/office-type.module.ts",
		"common",
		"office-type.module"
	],
	"./office/office.module": [
		"./src/app/modules/mutual/office/office.module.ts",
		"common",
		"office.module"
	],
	"./pay-scale/pay-scale.module": [
		"./src/app/modules/mutual/pay-scale/pay-scale.module.ts",
		"common",
		"pay-scale.module"
	],
	"./pay-stub/pay-stub.module": [
		"./src/app/modules/mutual/pay-stub/pay-stub.module.ts",
		"common",
		"pay-stub.module"
	],
	"./payment-category/payment-category.module": [
		"./src/app/modules/mutual/payment-category/payment-category.module.ts",
		"common",
		"payment-category.module"
	],
	"./payment-type/payment-type.module": [
		"./src/app/modules/mutual/payment-type/payment-type.module.ts",
		"common",
		"payment-type.module"
	],
	"./payroll-amount/payroll-amount.module": [
		"./src/app/modules/mutual/payroll-amount/payroll-amount.module.ts",
		"common",
		"payroll-amount.module"
	],
	"./payroll-concept/payroll-concept.module": [
		"./src/app/modules/mutual/payroll-concept/payroll-concept.module.ts",
		"common",
		"payroll-concept.module"
	],
	"./payroll-delete/payroll-delete.module": [
		"./src/app/modules/mutual/payroll-delete/payroll-delete.module.ts",
		"common",
		"payroll-delete.module"
	],
	"./payroll-summary/payroll-summary.module": [
		"./src/app/modules/mutual/payroll-summary/payroll-summary.module.ts",
		"common",
		"payroll-summary.module"
	],
	"./payroll-type/payroll-type.module": [
		"./src/app/modules/mutual/payroll-type/payroll-type.module.ts",
		"common",
		"payroll-type.module"
	],
	"./pension-ttype/pension-ttype.module": [
		"./src/app/modules/mutual/pension-ttype/pension-ttype.module.ts",
		"common",
		"pension-ttype.module"
	],
	"./plame-absence/plame-absence.module": [
		"./src/app/modules/mutual/plame-absence/plame-absence.module.ts",
		"common",
		"plame-absence.module"
	],
	"./plame-concept/plame-concept.module": [
		"./src/app/modules/mutual/plame-concept/plame-concept.module.ts",
		"common",
		"plame-concept.module"
	],
	"./plame-type/plame-type.module": [
		"./src/app/modules/mutual/plame-type/plame-type.module.ts",
		"common",
		"plame-type.module"
	],
	"./previous-job-title/previous-job-title.module": [
		"./src/app/modules/mutual/previous-job-title/previous-job-title.module.ts",
		"common",
		"previous-job-title.module"
	],
	"./previous-workplace/previous-workplace.module": [
		"./src/app/modules/mutual/previous-workplace/previous-workplace.module.ts",
		"common",
		"previous-workplace.module"
	],
	"./programmatic-structure/programmatic-structure.module": [
		"./src/app/modules/mutual/programmatic-structure/programmatic-structure.module.ts",
		"common",
		"programmatic-structure.module"
	],
	"./register/register.module": [
		"./src/app/modules/treasury/register/register.module.ts",
		"common",
		"register.module"
	],
	"./relationship-type/relationship-type.module": [
		"./src/app/modules/mutual/relationship-type/relationship-type.module.ts",
		"common",
		"relationship-type.module"
	],
	"./remote-work/remote-work.module": [
		"./src/app/modules/mutual/remote-work/remote-work.module.ts",
		"common",
		"remote-work.module"
	],
	"./report/income-summary/income-summary.module": [
		"./src/app/modules/treasury/report/income-summary/income-summary.module.ts",
		"common",
		"income-summary.module"
	],
	"./report/petty-cash/petty-cash.module": [
		"./src/app/modules/treasury/report/petty-cash/petty-cash.module.ts",
		"common",
		"petty-cash.module"
	],
	"./report/sales-record/sales-record.module": [
		"./src/app/modules/treasury/report/sales-record/sales-record.module.ts",
		"common",
		"sales-record.module"
	],
	"./report/sub-ledger/sub-ledger.module": [
		"./src/app/modules/treasury/report/sub-ledger/sub-ledger.module.ts",
		"common",
		"sub-ledger.module"
	],
	"./reports/attendance/absence-leave-date/absence-leave-date.module": [
		"./src/app/modules/mutual/reports/attendance/absence-leave-date/absence-leave-date.module.ts",
		"common",
		"absence-leave-date.module"
	],
	"./reports/attendance/attendance-summary/attendance-summary.module": [
		"./src/app/modules/mutual/reports/attendance/attendance-summary/attendance-summary.module.ts",
		"common",
		"attendance-summary.module"
	],
	"./reports/attendance/vacation-periods/vacation-periods.module": [
		"./src/app/modules/mutual/reports/attendance/vacation-periods/vacation-periods.module.ts",
		"common",
		"vacation-periods.module"
	],
	"./reports/employee/current-data/rpt-current-employee-data.module": [
		"./src/app/modules/mutual/reports/employee/current-data/rpt-current-employee-data.module.ts",
		"common",
		"rpt-current-employee-data.module"
	],
	"./reports/employee/high-and-low/rpt-high-and-low.module": [
		"./src/app/modules/mutual/reports/employee/high-and-low/rpt-high-and-low.module.ts",
		"common",
		"rpt-high-and-low.module"
	],
	"./reports/employee/nepotism/rpt-nepotism.module": [
		"./src/app/modules/mutual/reports/employee/nepotism/rpt-nepotism.module.ts",
		"common",
		"rpt-nepotism.module"
	],
	"./reports/payroll/afp-deduction/rpt-afp-deduction.module": [
		"./src/app/modules/mutual/reports/payroll/afp-deduction/rpt-afp-deduction.module.ts",
		"common",
		"rpt-afp-deduction.module"
	],
	"./reports/payroll/afp-employee-type/rpt-afp-employee-type.module": [
		"./src/app/modules/mutual/reports/payroll/afp-employee-type/rpt-afp-employee-type.module.ts",
		"common",
		"rpt-afp-employee-type.module"
	],
	"./reports/payroll/alphabetical/alphabetical.module": [
		"./src/app/modules/mutual/reports/payroll/alphabetical/alphabetical.module.ts",
		"common",
		"alphabetical.module"
	],
	"./reports/payroll/alphabetical2021/alphabetical2021.module": [
		"./src/app/modules/mutual/reports/payroll/alphabetical2021/alphabetical2021.module.ts",
		"common",
		"alphabetical2021.module"
	],
	"./reports/payroll/certificate-4th/rpt-certificate-4th.module": [
		"./src/app/modules/mutual/reports/payroll/certificate-4th/rpt-certificate-4th.module.ts",
		"common",
		"rpt-certificate-4th.module"
	],
	"./reports/payroll/concept-detail/rpt-concept-detail.module": [
		"./src/app/modules/mutual/reports/payroll/concept-detail/rpt-concept-detail.module.ts",
		"common",
		"rpt-concept-detail.module"
	],
	"./reports/payroll/deductions-by-employee-type/rpt-deductions-by-employee-type.module": [
		"./src/app/modules/mutual/reports/payroll/deductions-by-employee-type/rpt-deductions-by-employee-type.module.ts",
		"common",
		"rpt-deductions-by-employee-type.module"
	],
	"./reports/payroll/employee-annual-income/rpt-employee-annual-income.module": [
		"./src/app/modules/mutual/reports/payroll/employee-annual-income/rpt-employee-annual-income.module.ts",
		"common",
		"rpt-employee-annual-income.module"
	],
	"./reports/payroll/employer-contribution/rpt-employer-contribution.module": [
		"./src/app/modules/mutual/reports/payroll/employer-contribution/rpt-employer-contribution.module.ts",
		"common",
		"rpt-employer-contribution.module"
	],
	"./reports/payroll/eps-employee/rpt-eps-employee.module": [
		"./src/app/modules/mutual/reports/payroll/eps-employee/rpt-eps-employee.module.ts",
		"common",
		"rpt-eps-employee.module"
	],
	"./reports/payroll/job-certificate/rpt-job-certificate.module": [
		"./src/app/modules/mutual/reports/payroll/job-certificate/rpt-job-certificate.module.ts",
		"common",
		"rpt-job-certificate.module"
	],
	"./reports/payroll/pay-constancy/rpt-pay-constancy.module": [
		"./src/app/modules/mutual/reports/payroll/pay-constancy/rpt-pay-constancy.module.ts",
		"common",
		"rpt-pay-constancy.module"
	],
	"./reports/payroll/payroll-run-summary/rpt-payroll-run-summary.module": [
		"./src/app/modules/mutual/reports/payroll/payroll-run-summary/rpt-payroll-run-summary.module.ts",
		"common",
		"rpt-payroll-run-summary.module"
	],
	"./reports/payroll/rppm/rpt-rppm.module": [
		"./src/app/modules/mutual/reports/payroll/rppm/rpt-rppm.module.ts",
		"common",
		"rpt-rppm.module"
	],
	"./reports/payroll/summary-concept/rpt-summary-concept.module": [
		"./src/app/modules/mutual/reports/payroll/summary-concept/rpt-summary-concept.module.ts",
		"common",
		"rpt-summary-concept.module"
	],
	"./reports/payroll/way-to-pay/rpt-way-to-pay.module": [
		"./src/app/modules/mutual/reports/payroll/way-to-pay/rpt-way-to-pay.module.ts",
		"common",
		"rpt-way-to-pay.module"
	],
	"./rightholder-down/rightholder-down.module": [
		"./src/app/modules/mutual/rightholder-down/rightholder-down.module.ts",
		"common",
		"rightholder-down.module"
	],
	"./roleSystem/roleSystem.module": [
		"./src/app/_seguridad/roleSystem/roleSystem.module.ts",
		"common",
		"roleSystem.module"
	],
	"./seguimiento/seguimiento.module": [
		"./src/app/_seguridad/seguimiento/seguimiento.module.ts",
		"common",
		"seguimiento.module"
	],
	"./shift/shift.module": [
		"./src/app/modules/mutual/shift/shift.module.ts",
		"common",
		"shift.module"
	],
	"./shifting-list/shifting-list.module": [
		"./src/app/modules/mutual/shifting-list/shifting-list.module.ts",
		"common",
		"shifting-list.module"
	],
	"./snp-deduction/snp-deduction.module": [
		"./src/app/modules/mutual/snp-deduction/snp-deduction.module.ts",
		"common",
		"snp-deduction.module"
	],
	"./specialty/specialty.module": [
		"./src/app/modules/mutual/specialty/specialty.module.ts",
		"common",
		"specialty.module"
	],
	"./study-center-type/study-center-type.module": [
		"./src/app/modules/mutual/study-center-type/study-center-type.module.ts",
		"common",
		"study-center-type.module"
	],
	"./study-center/study-center.module": [
		"./src/app/modules/mutual/study-center/study-center.module.ts",
		"common",
		"study-center.module"
	],
	"./supporting-document/supporting-document.module": [
		"./src/app/modules/mutual/supporting-document/supporting-document.module.ts",
		"common",
		"supporting-document.module"
	],
	"./system-configuration/general-configuration/hhelpdesk-configuration/hhelpdesk-configuration.module": [
		"./src/app/modules/administrator/system-configuration/general-configuration/hhelpdesk-configuration/hhelpdesk-configuration.module.ts",
		"common",
		"hhelpdesk-configuration.module"
	],
	"./system-configuration/general-configuration/mhelpdesk-configuration/mhelpdesk-configuration.module": [
		"./src/app/modules/administrator/system-configuration/general-configuration/mhelpdesk-configuration/mhelpdesk-configuration.module.ts",
		"common",
		"mhelpdesk-configuration.module"
	],
	"./system-configuration/parameter-configuration/parameter-configuration.module": [
		"./src/app/modules/administrator/system-configuration/parameter-configuration/parameter-configuration.module.ts",
		"common",
		"parameter-configuration.module"
	],
	"./system-configuration/system-option/system-option.module": [
		"./src/app/modules/administrator/system-configuration/system-option/system-option.module.ts",
		"common",
		"system-option.module"
	],
	"./system-configuration/translation-detail/translation-detail.module": [
		"./src/app/modules/administrator/system-configuration/translation-detail/translation-detail.module.ts",
		"common",
		"translation-detail.module"
	],
	"./system-configuration/translation-text/translation-text.module": [
		"./src/app/modules/administrator/system-configuration/translation-text/translation-text.module.ts",
		"common",
		"translation-text.module"
	],
	"./termination-reason/termination-reason.module": [
		"./src/app/modules/mutual/termination-reason/termination-reason.module.ts",
		"common",
		"termination-reason.module"
	],
	"./timesheet/timesheet.module": [
		"./src/app/modules/mutual/timesheet/timesheet.module.ts",
		"common",
		"timesheet.module"
	],
	"./tupa/tupa.module": [
		"./src/app/modules/treasury/tupa/tupa.module.ts",
		"common",
		"tupa.module"
	],
	"./ubigeo/ubigeo.module": [
		"./src/app/modules/mutual/ubigeo/ubigeo.module.ts",
		"common",
		"ubigeo.module"
	],
	"./user-massive-load/user-massive-load.module": [
		"./src/app/modules/administrator/user-massive-load/user-massive-load.module.ts",
		"common",
		"user-massive-load.module"
	],
	"./user/users.module": [
		"./src/app/modules/administrator/user/users.module.ts",
		"common",
		"users.module"
	],
	"./userSystem/userSystem.module": [
		"./src/app/_seguridad/userSystem/userSystem.module.ts",
		"common",
		"userSystem.module"
	],
	"./vendor/vendor.module": [
		"./src/app/modules/mutual/vendor/vendor.module.ts",
		"common",
		"vendor.module"
	],
	"./via-type/via-type.module": [
		"./src/app/modules/mutual/via-type/via-type.module.ts",
		"common",
		"via-type.module"
	],
	"./voucher/voucher.module": [
		"./src/app/modules/treasury/voucher/voucher.module.ts",
		"common",
		"voucher.module"
	],
	"./zone-type/zone-type.module": [
		"./src/app/modules/mutual/zone-type/zone-type.module.ts",
		"common",
		"zone-type.module"
	],
	"app/+auth/+forgot/forgot.module": [
		"./src/app/+auth/+forgot/forgot.module.ts",
		"common",
		"forgot.module"
	],
	"app/+auth/+login/login.module": [
		"./src/app/+auth/+login/login.module.ts",
		"login.module"
	],
	"app/+auth/auth.module": [
		"./src/app/+auth/auth.module.ts",
		"auth.module"
	],
	"app/+home/home.module": [
		"./src/app/+home/home.module.ts",
		"common",
		"home.module"
	],
	"app/_seguridad/seguridad.module": [
		"./src/app/_seguridad/seguridad.module.ts",
		"seguridad.module"
	],
	"app/modules/accounting/accounting.module": [
		"./src/app/modules/accounting/accounting.module.ts",
		"common",
		"accounting.module"
	],
	"app/modules/administrator/administrator.module": [
		"./src/app/modules/administrator/administrator.module.ts",
		"common",
		"administrator.module"
	],
	"app/modules/mutual/mutual.module": [
		"./src/app/modules/mutual/mutual.module.ts",
		"common"
	],
	"app/modules/treasury/treasury.module": [
		"./src/app/modules/treasury/treasury.module.ts",
		"common",
		"treasury.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main